import { render, staticRenderFns } from "./didiPriceRelateOthersSelect.vue?vue&type=template&id=02715b1c&scoped=true&"
import script from "./didiPriceRelateOthersSelect.vue?vue&type=script&lang=js&"
export * from "./didiPriceRelateOthersSelect.vue?vue&type=script&lang=js&"
import style0 from "./didiPriceRelateOthersSelect.vue?vue&type=style&index=0&id=02715b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02715b1c",
  null
  
)

export default component.exports